export const Restaurant = `
	objectId
	name
	region
	address1
	address2
	city
	state
	postcode
	phone
	website
	instagramLink
	facebookLink
	twitterLink
	obeeGoLiveDate
	obeeToken
	premium
	closedEarly
	slug
	obeePlan
  timezone
`;

export const RestaurantForSwitcher = `
	objectId
	name
	address1
	address2
	city
	state
`;
